import React, { useState, useEffect } from 'react';
import { extractWorkbook, extractDataFromSheet } from '../../../sharecomponents/ExcelUtilities';
import { getUser, PHP_BACK } from '../../../../utils/Common';
import axios from "axios";
import Post from '../../../../utils/Post';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import TableHeadsData from '../../nomina/InventarioActividadesComponents/tableHeadsData';

const CargarExcel = () => {
    const [excel, setExcel] = useState({ workbook: undefined, hojas: [], hoja: "" });
    const [loader, setloader] = useState(false);
    const [dataNames, setDN] = useState([]);
    const [dataClean, setDC] = useState([]);
    const [dialog, setdialog] = useState({ show: false });
    const [FA, setFA] = useState({ section: 1, message: "Para cargar un plan de siembra solo seleccione el archivo Excel y después elija la hoja que desea cargar, si la hoja está en un formato válido se le mostrarán los archivos y la opción de guardarlos" });

    useEffect(() => {

    }, []);
    const loadWorbook = (e) => {
        setloader(true);
        extractWorkbook(e, setExcel, setloader);
    }

    const loadsheet = (e) => {
        let hoja = e.target.value;
        let de = { ...excel };
        de.hoja = hoja;
        setloader(true)
        setExcel(de);
        extractDataFromSheet(de, setDN, setDC, setloader, setFA);
    }

    const enviarExcel = async (enviar) => {
        if (!enviar) return;

        const user = getUser();
        setloader(true);
        let resp = await Post('excel/import', { data: dataClean, "userName": user.nombre, "userID": user.perfilId });
        setloader(false);

        setdialog({
            show: true,
            tipo: resp.estatus ? 'success' : 'error',
            title: resp.estatus ? 'Operación exitosa' : "Ups, ha ocurridó algo inesperado",
            body: resp.msj,
            size: 'm',
            funct: (resp) => { setdialog({ show: false }) }
        });

        if (resp.estatus) {
            setDN([]); setDC([]);
        }
    }

    return (
        <div className='col-lg-12  m-0 p-0 p-2' style={{ overflow: 'auto' }}>
            <div className='row justify-content-center  m-0 p-0'>
                <div className='col-lg-12'>
                    <div className='row justify-content-center m-0 p-0 mb-3'>
                        <div className='form-group mt-2' style={{ width: '300px' }}>
                            <label className="text-success text-bold  nowrap">Seleccionar archivo excel</label>
                            <input type='file' className='form-control form-control-sm' onChange={loadWorbook}
                                placeholder='Cargar archivo'
                                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
                        </div>

                        <div className='form-group mt-2' style={{ width: '250px' }}>
                            {excel.hojas && excel.hojas.length > 0 && <>
                                <label className="text-success text-bold  nowrap">Seleccionar hoja</label>
                                <select className='form-control form-control-sm' placeholder='' value={excel.hoja ?? ""} onChange={loadsheet}>
                                    <option value='' >Seleccione una</option>
                                    {
                                        excel.hojas.map((hoja) => {
                                            return (
                                                <option key={"hoja" + hoja} value={hoja}>{hoja}</option>
                                            )
                                        })
                                    }
                                </select>
                            </>
                            }
                        </div>
                        <div className='form-group contenedor align-items-end p-0 m-0 mt-4' style={{ width: '250px' }}>
                            {dataClean.length > 0 &&
                                <button type="button" className="btn btn-sm btn-success m-2 shadow" onClick={() => enviarExcel(true)} >
                                    <i className="fa fa-save mr-2" aria-hidden="true"></i>
                                    GUARDAR INFORMACIÓN
                                </button>
                            }
                        </div>

                    </div>
                </div>

                {dataClean.length === 0 && <div className='col-lg-12 m-5 text-l text-center text-300'>{FA.message}</div>}
                {dataClean.length != 0 && <TableHeadsData data={Array.isArray(dataClean) ? dataClean.slice(0, 300) : []} heads={dataNames} styleName={{ width: '100% !important', height: '63vh' }} />}
            </div>
            {loader && <div className=' blur-s' style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: '9999' }}>
                <div className='loader'></div>
            </div>}
            <VainillaDialog data={dialog} />
        </div>
    )
}

export default CargarExcel;